import { EnvironmentUrls } from 'Roblox';

const { websiteUrl } = EnvironmentUrls;

export default function getRobloxUrl(path: string): string {
  return `${websiteUrl}${path}`;
}
